import Select from './Select';
import withForm from '../Form/withForm';

const FormSelect = withForm(Select);

FormSelect.Option = Select.Option;
FormSelect.Divider = Select.Divider;

export default FormSelect;
